import axios from 'axios';
import {API_BASE_URL} from "../helper/env";
import {getDeviceType, getLocalAuthData} from "../helper/utils";

export const addSupplier = (data) => {
  const authData = getLocalAuthData();
  return new Promise((resolve, reject) => {
    axios.post(API_BASE_URL + '/suppliers', {supplier: data}, {
      headers: {}
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject('Something went wrong')
      })
  })
}

export const updateProduct = (id, data) => {
  const authData = getLocalAuthData();
  return new Promise((resolve, reject) => {
    axios.put(`${API_BASE_URL}/products/${id}`, data, {
      headers: {}
    })
      .then(res => {
        if (res.data.status === 1) {
          resolve(res.data);
        } else {
          reject(res.data.message);
        }
      })
      .catch(err => {
        console.log(err);
        reject('Something went wrong')
      })
  });
}

export const getProduct = () => {
  const authData = getLocalAuthData();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/products`, {
      headers: {}
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const deleteProduct = (id) => {
  const authData = getLocalAuthData();
  return new Promise((resolve, reject) => {
    axios.delete(`${API_BASE_URL}/products/${id}`, {
      headers: {}
    })
      .then(res => {
        if (res.data.status === 1) {
          resolve(res.data.message)
        } else {
          reject(res.data.message)
        }
      })
      .catch(err => {
        reject(err.message)
      })
  })
}

export const getAssignedProducts = supplier_id => {
  const authData = getLocalAuthData();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/suppliers/${supplier_id}/suppliers_variants`, {
      headers: {}
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getSupplierList = params => {
  const authData = getLocalAuthData();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/suppliers`, {
      params,
      headers: {}
    }).then(res => {
      console.log(res)
      if (res.data.error) {
        reject(res.data.error)
      } else {
        resolve(res)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}
